import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "../../services/api";

export const useProjects = () => {
  const {
    data: projects,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["projects"],
    queryFn: async () => {
      const data = await apiRequest("/projects");
      return data.data; // API returns { success: true, count: N, data: [...] }
    },
  });

  return { projects, isLoading, error };
};
